import { render, staticRenderFns } from "./chat-kpi.vue?vue&type=template&id=2d5c9e29&"
import script from "./chat-kpi.vue?vue&type=script&lang=js&"
export * from "./chat-kpi.vue?vue&type=script&lang=js&"
import style0 from "./chat-kpi.vue?vue&type=style&index=0&id=2d5c9e29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports